import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

class CollapseCardTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: (this.props.open !== undefined) ? this.props.open : true,
            title: (this.props.title !== undefined) ? this.props.title : ''
        }
    }

    showHide(element) {
        // if (this.props.childElements === 0) return;
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        const CustomTag = `h${this.props.level != null ? this.props.level : 4}`;
        return (
            <>
                <tr onClick={() => this.showHide()} className="align-items-center mb-4">
                    <td colSpan={this.props.colSpan} className="text-left border-top-0">
                        <CustomTag>{this.state.title} {this.props.childElements > 0 ? <>({this.props.childElements})</> : <></>}</CustomTag>
                    </td>
                    <td className='border-top-0'>
                        {this.props.total}
                    </td>
                    <td className="text-right border-top-0">
                        {this.props.button != null ?
                            <>{this.props.button}</>
                            : <></>}
                        {/*this.props.childElements > 0 ?*/ ((this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />)/* : <FontAwesomeIcon className="text-white" icon={faChevronUp} />*/}
                    </td>
                </tr>
                {this.state.open && this.props.children}
            </>
        )
    }
};

export default CollapseCardTable;